/* THG First-Party Back-in-Stock (Klaviyo client API).
   Fully document-delegated: nothing binds to swappable nodes, so variant
   changes / re-renders need zero re-init. The trigger's visibility is handled
   by the theme's buy-buttons script (toggles `show-notify` on the wrapper).
   On open the modal is portaled to <body> to escape any ancestor transform
   that would trap position:fixed under the header. */
(function () {
  'use strict';

  var KL_KEY = window.THG_KLAVIYO_KEY || 'RiLpr6';
  var REVISION = '2024-10-15';

  // Resolve the notify widget nearest a trigger (the sold-out ATC button).
  function resolveWidget(el) {
    var section = (el && el.closest('.shopify-section')) || document;
    return section.querySelector('[data-thg-notify]') || document.querySelector('[data-thg-notify]');
  }

  /* Read the currently selected variant id from the live product form input
     that the theme keeps in sync, falling back to the URL param. */
  function currentVariantId() {
    var input = document.querySelector('[data-variant-info="variant_id"]');
    if (input && input.value) return String(input.value);
    var byId = document.querySelector('input[name="id"]');
    if (byId && byId.value) return String(byId.value);
    var p = new URLSearchParams(window.location.search).get('variant');
    return p ? String(p) : null;
  }

  function variantMeta(widget, variantId) {
    var json = widget.querySelector('[data-thg-notify-variants]');
    if (!json) return null;
    try {
      var list = JSON.parse(json.textContent);
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(variantId)) return list[i];
      }
    } catch (e) {}
    return null;
  }

  function setView(modal, name) {
    modal.querySelectorAll('[data-thg-notify-view]').forEach(function (v) {
      if (v.getAttribute('data-thg-notify-view') === name) {
        v.removeAttribute('hidden');
      } else {
        v.setAttribute('hidden', '');
      }
    });
  }

  /* Ancestor transforms in the product section trap position:fixed and let the
     header paint over the modal, so it's portaled to <body> on first open. Once
     portaled it's no longer a descendant of the widget, so cache it on the
     widget and reuse it (re-resolving fresh only if it's been torn out of the
     DOM, e.g. after an AJAX color swap replaced the section). */
  function modalFor(widget) {
    if (widget.__thgModal && document.body.contains(widget.__thgModal)) return widget.__thgModal;
    var modal = widget.querySelector('[data-thg-notify-modal]');
    if (modal) {
      document.querySelectorAll('body > [data-thg-notify-modal]').forEach(function (m) { m.remove(); });
      document.body.appendChild(modal);
      modal.__thgWidget = widget;
      widget.__thgModal = modal;
    }
    return modal;
  }

  function openModal(widget) {
    if (!widget) return;
    var modal = modalFor(widget);
    if (!modal) return;

    // Reset to the form view + fill the variant label from live selection.
    setView(modal, 'form');
    var err = modal.querySelector('[data-thg-notify-error]');
    if (err) { err.setAttribute('hidden', ''); err.textContent = ''; }

    var vid = currentVariantId();
    var label = modal.querySelector('[data-thg-notify-variant]');
    if (label) {
      var meta = variantMeta(widget, vid);
      label.textContent = meta && meta.title && meta.title !== 'Default Title' ? meta.title : '';
    }

    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('thg-notify-open');

    var email = modal.querySelector('[data-thg-notify-email]');
    if (email) { email.value = ''; setTimeout(function () { email.focus(); }, 60); }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('thg-notify-open');
  }

  function submit(modal) {
    var widget = modal.__thgWidget;
    var emailEl = modal.querySelector('[data-thg-notify-email]');
    var errEl = modal.querySelector('[data-thg-notify-error]');
    var btn = modal.querySelector('[data-thg-notify-submit]');
    var email = emailEl ? emailEl.value.trim() : '';

    function fail(msg) {
      if (errEl) { errEl.textContent = msg; errEl.removeAttribute('hidden'); }
      if (btn) { btn.disabled = false; btn.textContent = 'Notify Me'; }
    }

    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      return fail('Please enter a valid email address.');
    }

    var vid = currentVariantId();
    if (!vid) return fail('Something went wrong. Please refresh and try again.');

    if (btn) { btn.disabled = true; btn.textContent = 'Submitting...'; }
    if (errEl) errEl.setAttribute('hidden', '');

    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(KL_KEY), {
      method: 'POST',
      /* Klaviyo's Cloudflare edge 403s this endpoint when a Referer is sent. */
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (res.status === 200 || res.status === 201 || res.status === 202) {
          setView(modal, 'success');
        } else {
          return res.text().then(function () { fail("Couldn't sign you up. Please try again."); });
        }
      })
      .catch(function () { fail('Network error. Please try again.'); });
  }

  /* ---- Delegated listeners (document-level, swap-proof) ---- */

  // Capture phase: intercept the sold-out ATC button BEFORE the theme's
  // add-to-cart handler and cancel the form submit, then open the modal.
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-thg-notify-atc]');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      openModal(resolveWidget(atc));
    }
  }, true);

  // Belt-and-suspenders: never let a notify-state form actually submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.querySelector && form.querySelector('[data-thg-notify-atc]')) {
      e.preventDefault();
      openModal(resolveWidget(form));
    }
  }, true);

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-thg-notify-close]');
    if (closer) { e.preventDefault(); closeModal(closer.closest('[data-thg-notify-modal]')); return; }

    var sub = e.target.closest('[data-thg-notify-submit]');
    if (sub) { e.preventDefault(); submit(sub.closest('[data-thg-notify-modal]')); return; }
  });

  // Enter inside the email field submits without bubbling to the product form.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-thg-notify-email]')) {
      e.preventDefault();
      submit(e.target.closest('[data-thg-notify-modal]'));
    }
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-thg-notify-modal]:not([hidden])');
      if (open) closeModal(open);
    }
  });
})();
